import React from 'react';

const SectionTabs = ({ sections, activeSection, onSelect }) => (
  <div className="section-tabs-wrap">
    <div className="section-tabs-label">Sections</div>

    <div className="section-tabs">
      {Array.isArray(sections) && sections.length ? (
        sections.map(section => {
          const active =
            section.section_name === activeSection;

          return (
            <button
              type="button"
              key={section.sec_id}
              className={`section-tab ${active ? 'active' : ''}`}
              onClick={() =>
                onSelect(
                  section.sec_id,
                  section.section_name
                )
              }
            >
              {section.section_name}
            </button>
          );
        })
      ) : (
        <span className="section-empty">No sections available</span>
      )}
    </div>
  </div>
);

export default SectionTabs;
